import { useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { trpc } from "@/trpc/trpc";

/**
 * Switches the panel to another salon.
 *
 * The active salon is implicit on the server (it is not part of any query
 * input), so cache keys are identical across salons — the whole cache has to
 * go after a successful switch, otherwise the panel keeps showing the previous
 * salon's data. On failure nothing is touched: the server rejects with an
 * error and the panel stays on the salon it was on.
 */
export function useSwitchSalon() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const mutation = trpc.salon.switchSalon.useMutation({
    onSuccess: () => {
      queryClient.clear();
      navigate({ to: "/" });
    },
    onError: (error) => {
      toast.error(error.message || "Nie udało się przełączyć salonu");
    },
  });

  return {
    switchTo: (salonId: string) => mutation.mutate({ salonId }),
    isPending: mutation.isPending,
    pendingSalonId: mutation.isPending ? mutation.variables?.salonId : null,
  };
}
